<template>
    <vs-dialog width="550px" blur not-center v-model="active">
        <template #header>
            <h4 class="not-margin">
            Confirmacion de <b>Borrado</b>
            </h4>
        </template>


        <div class="con-content">
            <p>
            Desea borrar el codigo de sesion {{rowData instanceof Object && rowData.alias ? rowData.alias : ''}}
            </p>
        </div>

        <template #footer>
            <div class="con-footer">
            <vs-button @click="deleteRow" transparent>
                Ok
            </vs-button>
            <vs-button @click="active=false" dark transparent>
                Cancel
            </vs-button>
            </div>
        </template>
    </vs-dialog>
</template>
<script>
import crns from '../../../../../api/requests/crns'
export default {
    props:[
        'value',
        'rowData'
    ],
    data () {
        return {
            active: false
        }
    },
    methods: {
        async deleteRow () {
            try {
                const response = await crns.deleteCrn(this.rowData.id)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Exito',
                    text: `Registro eliminado`
                })
                this.$emit('refreshTable',true)
                this.active = false
            } catch (error) {
                this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error',
                        text: `Algo salió mal`
                })
            }
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>
<style scoped>
    .con-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .con-footer .vs-button .vs-button__content {
        padding: 10px 30px;
    }
    .con-footer .vs-button {
        margin: 0;
    }
    .not-margin {
        margin: 0;
        font-weight: 400;
        padding: 10px 10px 0;
    }
    .con-content {
        justify-content: space-between;
        width: 100%;
    }
    .con-content p {
        font-size: .8rem;
        padding: 0 10px;
    }
    .con-content, .con-content>div {
        display: flex;
        align-items: center;
    }
</style>